























export default {
  name: 'TaxDetails',
  props: ['data'],
  data() {
    return {
      notApplicableAccountTypes: ['Company', 'Trust', 'Superannuation'],
      taxDetails: this.data.taxDetails[0],
    };
  },
  computed: {
    satoClaimed() {
      if (this.notApplicableAccountType(this.data.accountType)) {
        return 'Not applicable';
      }
      return this.taxDetails.satoClaimed || 'N/A';
    },
    tftClaimed() {
      if (this.notApplicableAccountType(this.data.accountType)) {
        return 'Not applicable';
      }
      return this.taxDetails.tftClaimed ? 'Yes' : 'No';
    },
  },
  methods: {
    notApplicableAccountType(accountType) {
      return this.notApplicableAccountTypes.includes(this.splitAccountType(accountType));
    },
    splitAccountType(accountType) {
      return accountType.split('/')[0];
    },
  },
};
